import { Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { TemplateBusinessService } from '../../business-services/template-service';


@Injectable({ providedIn: 'root' })
export class EditTemplateGuard  {

  constructor(
    private service: TemplateBusinessService,
    private router: Router
  ) { }

  canActivate(): Promise<UrlTree | boolean> | Observable<UrlTree | boolean> | UrlTree | boolean {
    if (this.service.templateId) {
      return true;
    }
    return this.router.createUrlTree(['/template']);
  }
}
